import Cookie from 'js-cookie';

import { NAV_AVAILABLE_IDENTIFIERS, NAV_UNIVERSE_COOKIE } from '../settings/nav';
import { getFooter, getFooterMobile, getMetanav, getNavMobile, getNavMobileLinks, getSubnav } from '../services/nav';

export function getActiveMenu() {
  return Cookie.get(NAV_UNIVERSE_COOKIE);
}

export function getChannel() {
  return NAV_AVAILABLE_IDENTIFIERS[getActiveMenu()] || 'onedior';
}

export function isPcd() {
  return NAV_AVAILABLE_IDENTIFIERS[getActiveMenu()] === 'pcd';
}

export const TOGGLE_NAV_MOBILE = 'TOGGLE_NAV_MOBILE';
export function toggleNavMobile(dispatch, isOpen) {
  dispatch({
    type: TOGGLE_NAV_MOBILE,
    data: !isOpen
  });
}

export const RECEIVE_NAV_MOBILE = 'RECEIVE_NAV_MOBILE';
export const NAV_MOBILE_NOT_LOADED = 0;
export const NAV_MOBILE_LOADING = 1;
export const NAV_MOBILE_LOADED = 2;
let navMobileLoadState = NAV_MOBILE_NOT_LOADED;
export function fetchNavMobile(dispatch) {
  if (navMobileLoadState === NAV_MOBILE_NOT_LOADED) {
    navMobileLoadState = NAV_MOBILE_LOADING;
    getNavMobile()
      .then(json => dispatch({
        type: RECEIVE_NAV_MOBILE,
        data: json
      }))
      .then(() => navMobileLoadState = NAV_MOBILE_LOADED);
  }
}

export const RECEIVE_NAV_MOBILE_LINKS = 'RECEIVE_NAV_MOBILE_LINKS';
export const NAV_MOBILE_LINKS_NOT_LOADED = 0;
export const NAV_MOBILE_LINKS_LOADING = 1;
export const NAV_MOBILE_LINKS_LOADED = 2;
let navMobileLinksLoadState = NAV_MOBILE_LINKS_NOT_LOADED;
export function fetchNavMobileLinks(dispatch) {
  if (navMobileLinksLoadState === NAV_MOBILE_LINKS_NOT_LOADED) {
    navMobileLinksLoadState = NAV_MOBILE_LINKS_LOADING;
    getNavMobileLinks()
      .then(json => dispatch({
        type: RECEIVE_NAV_MOBILE_LINKS,
        data: json
      }))
      .then(() => navMobileLinksLoadState = NAV_MOBILE_LINKS_LOADED);
  }
}

export const RECEIVE_METANAV = 'RECEIVE_METANAV';
export const METANAV_NOT_LOADED = 0;
export const METANAV_LOADING = 1;
export const METANAV_LOADED = 2;
let metanavLoadState = METANAV_NOT_LOADED;
export function fetchMetanav(dispatch) {
  if (metanavLoadState === METANAV_NOT_LOADED) {
    metanavLoadState = METANAV_LOADING;
    getMetanav()
      .then(json => dispatch({
        type: RECEIVE_METANAV,
        data: json
      }))
      .then(() => metanavLoadState = METANAV_LOADED);
  }
}

export const RECEIVE_SUBNAV = 'RECEIVE_SUBNAV';
export const SUBNAV_NOT_LOADED = 0;
export const SUBNAV_LOADING = 1;
export const SUBNAV_LOADED = 2;
let subnavLoadState = SUBNAV_NOT_LOADED;
export function fetchSubnav(dispatch, activeMenu) {
  if (subnavLoadState === SUBNAV_NOT_LOADED) {
    subnavLoadState = SUBNAV_LOADING;
    getSubnav(activeMenu)
      .then(json => dispatch({
        type: RECEIVE_SUBNAV,
        data: json
      }))
      .then(() => subnavLoadState = SUBNAV_LOADED);
  }
}

export const RECEIVE_FOOTER = 'RECEIVE_FOOTER';
export const FOOTER_NOT_LOADED = 0;
export const FOOTER_LOADING = 1;
export const FOOTER_LOADED = 2;
let footerLoadState = FOOTER_NOT_LOADED;
export function fetchFooter(dispatch) {
  if (footerLoadState === FOOTER_NOT_LOADED) {
    footerLoadState = FOOTER_LOADING;
    getFooter()
      .then(json => dispatch({
        type: RECEIVE_FOOTER,
        data: json
      }))
      .then(() => footerLoadState = FOOTER_LOADED);
  }
}

export const RECEIVE_FOOTER_MOBILE = 'RECEIVE_FOOTER_MOBILE';
export const FOOTER_MOBILE_NOT_LOADED = 0;
export const FOOTER_MOBILE_LOADING = 1;
export const FOOTER_MOBILE_LOADED = 2;
let footerMobileLoadState = FOOTER_MOBILE_NOT_LOADED;
export function fetchFooterMobile(dispatch) {
  if (footerMobileLoadState === FOOTER_MOBILE_NOT_LOADED) {
    footerMobileLoadState = FOOTER_MOBILE_LOADING;
    getFooterMobile()
      .then(json => dispatch({
        type: RECEIVE_FOOTER_MOBILE,
        data: json
      }))
      .then(() => footerMobileLoadState = FOOTER_MOBILE_LOADED);
  }
}



// WEBPACK FOOTER //
// ./src/actions/nav.js